document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".testimonials .swiper");

  sliders.forEach((slider) => {
    // Below the 3-item threshold the block renders a plain grid fallback
    // (swiper-wrapper-disabled instead of swiper-wrapper) with no wrapper
    // for Swiper to mount onto — skip init or it throws on getComputedStyle.
    if (!slider.querySelector(".swiper-wrapper")) {
      return;
    }

    new Swiper(slider, {
      loop: false,
      slidesPerView: 1.2,
      spaceBetween: 20,
      watchSlidesVisibility: true,
      centeredSlides: false,
      loopAdditionalSlides: 1,
      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },

      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true,
      },

      breakpoints: {
        768: {
          slidesPerView: 1.8,
          spaceBetween: 30,
        },
        991: {
          slidesPerView: 2.1,
          spaceBetween: 30,
        },
        1199: {
          slidesPerView: 2.2,
          spaceBetween: 30,
        },
      },
    });
  });
});